import React from 'react';
import { connect } from 'react-redux';
import { setCurrentUser, setProgress, setCurrentUserDbId, setTeacherDbId } from '../store/UserReducer';
import Api from '../Api';
import Progress from '../Progress';
import './LoginPage2.scss';
import { MAX_CLASS_SIZE } from './Classroom';

export class _LoginPage2 extends React.Component {
  constructor(props) {
    super(props);
    console.log("LoginPage2", props);

    this.state = {
      // Student login
      teacherId: '',
      userName: '',
      studentError: false,
      studentErrorMessage: '',
      showSubscribeMessage: false,
      showCreateStudentPrompt: false,
      pendingTeacherEmail: '',
      // Educator login
      educatorEmail: '',
      educatorPassword: '',
      educatorError: false,
      educatorErrorMessage: '',
      // Shared
      working: false,
      loginType: 'student',
    };
  }

  switchToEducator = () => {
    this.setState({ loginType: 'educator' }, () => {
      document.getElementById('e-email-input').focus();
    });
  }

  switchToStudent = () => {
    this.setState({ loginType: 'student' }, () => {
      document.getElementById('s-teacher-input').focus();
    });
  }

  // --- Student login ---

  showStudentError = (text, focusId) => {
    document.getElementById(focusId).focus();
    this.setState({ studentErrorMessage: text, studentError: true });
  }

  hideStudentError = () => {
    this.setState({ studentErrorMessage: '', studentError: false });
  }

  onCreateStudentYes = async () => {
    this.setState({ showCreateStudentPrompt: false, working: true });
    try {
      const teacher = await Api.getTeacherByEmail(this.state.pendingTeacherEmail);
      const student = await Api.addStudent(teacher.teacherId, this.state.userName.trim());
      this.props.setUser(student.name);
      this.props.setUserDbId(student.studentId);
      this.props.setTeacherDbId(student.teacherId);
      this.props.setProgress(JSON.parse(student.progress));
      this.props.newUserLogin(this.state.teacherId, this.state.userName);
    } catch (error) {
      console.log("caught error creating student:", error);
      this.showStudentError("Failed to create student account", 's-login-input');
    } finally {
      this.setState({ working: false });
    }
  }

  onCreateStudentNo = () => {
    this.setState({ showCreateStudentPrompt: false, pendingTeacherEmail: '' });
  }

  onChangeTeacherId = (event) => {
    this.setState({ teacherId: event.target.value });
  }

  onChangeUserName = (event) => {
    this.setState({ userName: event.target.value });
  }

  onStudentSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();
    this.hideStudentError();
    this.setState({ showSubscribeMessage: false });

    if (this.state.teacherId.trim() === '') {
      this.showStudentError("Type your member's email or username", 's-teacher-input');
    } else if (this.state.userName.trim() === '') {
      this.showStudentError("Type the student's full name", 's-login-input');
    } else {
      this.setState({ working: true }, () => setTimeout(async () => {
        try {
          console.time("checkSubscription");
          const status = Api.checkSubscription(this.state.teacherId.trim());
          console.timeEnd("checkSubscription");
          if (status) {
            if (status.success && (   status.status === "Active"
                                   || status.status === "Pending Cancellation"
                                   || status.status === "Free Trial"
                                   || status.status === "Complimentary")) {
              console.time("loginUser");
              const user = Api.loginUser(status.email, this.state.userName.trim());
              console.timeEnd("loginUser");
              console.log("LOGIN GOT A USER", user);
              if (user === null) {
                const students = await Api.getStudentsByTeacher(status.email);
                if (students.length < MAX_CLASS_SIZE) {
                  this.setState({ showCreateStudentPrompt: true, pendingTeacherEmail: status.email });
                } else {
                  this.showStudentError("Student not found, and no more students can be added to this class.", 's-login-input');
                }
              } else if (user.teacherId) {
                if (user.studentId) {
                  this.props.setUser(user.name);
                  this.props.setUserDbId(user.studentId);
                  this.props.setTeacherDbId(user.teacherId);
                  this.props.setProgress(user.progress);
                  this.props.newUserLogin(this.state.teacherId, this.state.userName);
                } else {
                  this.showStudentError("Unknown Student or Member", 's-teacher-input');
                }
              } else {
                this.showStudentError("Unknown Member", 's-teacher-input');
              }
            } else {
              this.setState({ showSubscribeMessage: true });
            }
          } else {
            this.setState({ showSubscribeMessage: true });
          }
        } catch (error) {
          console.log("caught error:", error);
          this.showStudentError("Are you sure you're connected to the internet?", 's-teacher-input');
        } finally {
          this.setState({ working: false });
        }
      }, 0));
    }
  }

  // --- Educator login ---

  onChangeEducatorEmail = (event) => {
    this.setState({ educatorEmail: event.target.value });
  }

  onChangeEducatorPassword = (event) => {
    this.setState({ educatorPassword: event.target.value });
  }

  onEducatorSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();
    this.setState({ educatorError: false, educatorErrorMessage: '' });

    if (this.state.educatorEmail.trim() === '') {
      document.getElementById('e-email-input').focus();
      this.setState({ educatorError: true, educatorErrorMessage: 'Type your teacher email' });
    } else if (this.state.educatorPassword.trim() === '') {
      document.getElementById('e-password-input').focus();
      this.setState({ educatorError: true, educatorErrorMessage: 'Type your password' });
    } else if (this.state.educatorPassword !== 'timesalive!') {
      document.getElementById('e-password-input').focus();
      this.setState({ educatorError: true, educatorErrorMessage: 'Incorrect password' });
    } else {
      this.setState({ working: true }, () => setTimeout(() => {
        try {
          console.time("checkSubscription");
          const status = Api.checkSubscription(this.state.educatorEmail.trim());
          console.timeEnd("checkSubscription");
          if (status) {
            if (status.success && (   status.status === "Active"
                                   || status.status === "Pending Cancellation"
                                   || status.status === "Free Trial"
                                   || status.status === "Complimentary")) {
              this.props.onEducatorLogin(this.state.educatorEmail, status.status);
            } else {
              this.setState({ educatorError: true, educatorErrorMessage: "No active membership found for that email address" });
            }
          } else {
            this.setState({ educatorError: true, educatorErrorMessage: "No active membership found for that email address" });
          }
        } catch (error) {
          console.log("caught error:", error);
          document.getElementById('e-email-input').focus();
          this.setState({ educatorError: true, educatorErrorMessage: "Are you sure you're connected to the internet?" });
        } finally {
          this.setState({ working: false });
        }
      }, 0));
    }
  }

  render() {
    console.log("LoginPage2 render()");
    const isStudent = this.state.loginType === 'student';
    return (
      <div className="login2-page">
        {this.state.working && (
          <div className="login2-working-overlay">
            <div className="login2-working-box">Authenticating&hellip;</div>
          </div>
        )}
        <div className="login2-panel">

          {isStudent ? (
            <>
              <div className="login2-panel-title-row">
                <h2 className="login2-panel-title">Student Login</h2>
                <button type="button" className="login2-switch-link" onClick={this.switchToEducator}>
                  Teacher Login &rsaquo;
                </button>
              </div>
              <form onSubmit={this.onStudentSubmit}>
                <label className="login2-label" htmlFor="s-teacher-input">Member's Email or Username</label>
                <input
                  id="s-teacher-input"
                  className="login2-input"
                  type="text"
                  autoFocus
                  autoComplete="off"
                  value={this.state.teacherId}
                  onChange={this.onChangeTeacherId}
                />
                <label className="login2-label" htmlFor="s-login-input">Student's Name</label>
                <input
                  id="s-login-input"
                  className="login2-input"
                  type="text"
                  autoComplete="off"
                  value={this.state.userName}
                  onChange={this.onChangeUserName}
                />
                <div className="login2-button-row">
                  <input
                    className="login2-enter-button"
                    type="submit"
                    value="ENTER"
                  />
                  {this.state.studentError && (
                    <div className="login2-error">{this.state.studentErrorMessage}</div>
                  )}
                </div>
                {this.state.showSubscribeMessage && (
                  <div className="login2-subscribe-msg">
                    OOPS! We don't have a membership for that email address. Try again or sign up at{' '}
                    <a href="https://www.citycreek.com/shop" title="City Creek Press, Inc." rel="noopener noreferrer" target="_blank">
                      https://www.citycreek.com/shop
                    </a>.
                  </div>
                )}
                {this.state.showCreateStudentPrompt && (
                  <div className="login2-create-prompt">
                    <div className="login2-create-prompt-text">
                      Student not found. Would you like to add <strong>{this.state.userName}</strong>?
                    </div>
                    <div className="login2-create-prompt-buttons">
                      <button type="button" className="login2-create-yes" onClick={this.onCreateStudentYes}>Yes</button>
                      <button type="button" className="login2-create-no" onClick={this.onCreateStudentNo}>No</button>
                    </div>
                  </div>
                )}
              </form>
            </>
          ) : (
            <>
              <div className="login2-panel-title-row">
                <button type="button" className="login2-switch-link" onClick={this.switchToStudent}>
                  &lsaquo; Student Login
                </button>
                <h2 className="login2-panel-title">Teacher Login</h2>
              </div>
              <form onSubmit={this.onEducatorSubmit}>
                <label className="login2-label" htmlFor="e-email-input">Member's Email</label>
                <input
                  id="e-email-input"
                  className="login2-input"
                  type="text"
                  autoComplete="off"
                  value={this.state.educatorEmail}
                  onChange={this.onChangeEducatorEmail}
                />
                <label className="login2-label" htmlFor="e-password-input">Password</label>
                <input
                  id="e-password-input"
                  className="login2-input"
                  type="password"
                  autoComplete="off"
                  value={this.state.educatorPassword}
                  onChange={this.onChangeEducatorPassword}
                />
                <div className="login2-button-row">
                  <input
                    className="login2-enter-button"
                    type="submit"
                    value="ENTER"
                  />
                  {this.state.educatorError && (
                    <div className="login2-error">{this.state.educatorErrorMessage}</div>
                  )}
                </div>
                <div>
                  <p>
                    Need password? Click here:&nbsp;
                    <a href="https://www.citycreek.com/help" title="City Creek Press, Inc." rel="noopener noreferrer" target="_blank">
                      https://www.citycreek.com/help
                    </a>
                  </p>
                </div>
              </form>
            </>
          )}

        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  setUser: (userName) => dispatch(setCurrentUser(userName)),
  setProgress: (progress) => dispatch(setProgress(progress)),
  setUserDbId: (id) => dispatch(setCurrentUserDbId(id)),
  setTeacherDbId: (id) => dispatch(setTeacherDbId(id))
});

export const LoginPage2 = connect(null, mapDispatchToProps)(_LoginPage2);
